/* Model */
class DriverProfileCostModel extends App.Models.BaseModel {
    modelUrl = 'DriverProfileCost';
}

App.Models.DriverProfileCost = DriverProfileCostModel;

/* Collection */
class DriverProfileCostCollection extends App.Collections.BaseCollection {
    url = 'DriverProfileCost';
    model = App.Models.DriverProfileCost;
}

App.Collections.DriverProfileCosts = DriverProfileCostCollection;

/* Router */
class DriverProfileCostRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'DriverProfileCost';
        const model = App.Models.DriverProfileCost;
        const collectionClass = App.Collections.DriverProfileCosts;

        super(entityName, model, collectionClass);
    }

    afterCreateForm = () => {
        const inputSelector = "#DriverProfileCost_minimumDistance label";
        const inputPerDistanceRateKm = "#DriverProfileCost_perDistanceRateKm label";

        Monet.FormBuilder.appendUnitySystemMetricToLabel(inputSelector);
        Monet.FormBuilder.appendUnitySystemMetricToLabel(inputPerDistanceRateKm);
    };

    onValidate = () => {
        const fieldsToCheck = ['perSize1Rate', 'perSize2Rate', 'perSize3Rate', 'minimumSize1', 'minimumSize2', 'minimumSize3'];
        const fieldsForm = App.Forms[this.entityName].form.fields;
        const fields = {};
        let allFieldsAreEmpty = true;

        const invalidateFields = () => {
            fieldsToCheck.forEach( field => {
                if(!fieldsForm[field].getValue().toString()) {
                    fieldsForm[field].rootEl.className = fieldsForm[field].rootEl.className.replace('control-group error', '');
                    fieldsForm[field].rootEl.className = fieldsForm[field].rootEl.className + ' control-group error';
                }
            });

            this.allow_submit.errorMessages.push(
                Monet.Form.Messages.mountErrorMessageObject('driverProfileCost.error.sectionSizeRequired')
            );
            this.allow_submit.status = false;
        };

        fieldsToCheck.forEach( field => {
            fields[field] = fieldsForm[field].getValue().toString();
            if(fields[field]) allFieldsAreEmpty = false;
        });

        if(allFieldsAreEmpty) {
            invalidateFields();
        } else {
            let someFieldInASectionSizeIsEmpty = true;
            if(fields.perSize1Rate && fields.minimumSize1) {
                someFieldInASectionSizeIsEmpty = false;
            }
            
            if(someFieldInASectionSizeIsEmpty && (fields.perSize2Rate && fields.minimumSize2)) {
                someFieldInASectionSizeIsEmpty = false;
            }

            if(someFieldInASectionSizeIsEmpty && (fields.perSize3Rate && fields.minimumSize3)) {
                someFieldInASectionSizeIsEmpty = false;
            }

            (someFieldInASectionSizeIsEmpty) && invalidateFields(); 
        }
    };
}

App.Routers.DriverProfileCost = DriverProfileCostRouter;
